import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';
import {RequestEditWizardNew} from './sf-payroll-wizard.dto';

@Injectable()
export class SfPayrollWizardProvider {
  private readonly service: string = 'payroll';
  private readonly model: string = 'sfPayrollWizard';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public getWizard(flag?: any, taxyear?: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getWizard';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof flag !== 'undefined' && flag !== null) _urlParams.flag = flag;
    if (typeof taxyear !== 'undefined' && taxyear !== null) _urlParams.taxyear = taxyear;

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, {}, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getTeorcompbank(companyId: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getTeorcompbank';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof companyId !== 'undefined' && companyId !== null) _urlParams.companyId = companyId;

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, {}, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getTpymbank(param: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getTpymbank';
    const _params: any = {};
    let _urlParams: any = {};
    const _body: any = {};
    
    if (typeof param) _urlParams = param;
    // if (typeof bankCode) _urlParams = bankCode;

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, {}, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public editWizard(params: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'editWizard';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    // if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, {}, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getPfDetail(pfPolicyId: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getPfDetail';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof pfPolicyId !== 'undefined' && pfPolicyId !== null) _urlParams.pfPolicyId = pfPolicyId;

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, _params, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public editWizardNew(payload: RequestEditWizardNew): Observable<any> {
    const method: string = 'POST';
    const func: string = 'editWizardNew';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/sf-payroll/sf-payroll-wizard.ts